export const tvs = [
  {
    id: 'tv-1',
    kind: 'tv' as const,
    title: '长安风云录',
    poster: 'https://readdy.ai/api/search-image?query=epic%20chinese%20historical%20drama%20poster%2C%20ancient%20palace%20courtyard%20at%20dusk%2C%20imperial%20robes%20silhouette%2C%20rich%20red%20and%20gold%20palace%20tones%2C%20dramatic%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=tv-poster-01&orientation=portrait',
    genres: ['古装', '历史'],
    region: '国产',
    year: 2024,
    episodes: 40,
    status: '完结' as const,
    director: '司马长风',
    cast: ['裴清', '李元昭', '萧皇后'],
    rating: 8.5,
    popularity: 94,
    synopsis:
      '故事围绕一座繁华都城展开，讲述了年轻的御史如何在错综复杂的朝堂之上查明冤案、匡扶公道。权谋、家国与个人抉择交织，勾勒出一幅波澜壮阔的历史长卷。制作考究、服化道精良，是近年少见的正剧佳作。'
  },
  {
    id: 'tv-2',
    kind: 'tv' as const,
    title: '都市医生',
    poster: 'https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%2C%20bright%20modern%20hospital%20corridor%2C%20confident%20doctors%20in%20scrubs%2C%20clean%20cool%20blue%20and%20white%20tones%2C%20professional%20hopeful%20mood%2C%20no%20text&width=400&height=600&seq=tv-poster-02&orientation=portrait',
    genres: ['职场', '剧情'],
    region: '国产',
    year: 2025,
    episodes: 36,
    status: '连载' as const,
    director: '方知远',
    cast: ['沈一帆', '林知夏', '郝主任'],
    rating: 8.0,
    popularity: 90,
    synopsis:
      '在一家三甲医院的急诊科，一群医务工作者每天都在和时间赛跑。年轻的住院医师在前辈的带教下迅速成长，也逐渐理解了"医者仁心"的分量。剧集真实还原急诊日常，聚焦医患关系与职业理想。'
  },
  {
    id: 'tv-3',
    kind: 'tv' as const,
    title: '迷雾侦探',
    poster: 'https://readdy.ai/api/search-image?query=mystery%20detective%20series%20poster%2C%20foggy%20victorian%20street%20with%20gas%20lamps%2C%20detective%20in%20coat%2C%20moody%20grey%20blue%20tones%2C%20intriguing%20suspenseful%20atmosphere%2C%20no%20text&width=400&height=600&seq=tv-poster-03&orientation=portrait',
    genres: ['悬疑', '推理'],
    region: '欧美',
    year: 2024,
    episodes: 24,
    status: '完结' as const,
    director: 'Arthur Blake',
    cast: ['Oliver Reed', 'Clara West', 'James Doyle'],
    rating: 8.7,
    popularity: 92,
    synopsis:
      '一位擅长观察细节的私家侦探，在一座常年笼罩浓雾的城市里接连破解离奇案件。每一集都是一个独立的谜题，同时又暗藏着一条贯穿全季的主线。剧本缜密、氛围迷人，是推理爱好者不容错过的作品。'
  },
  {
    id: 'tv-4',
    kind: 'tv' as const,
    title: '甜心食堂',
    poster: 'https://readdy.ai/api/search-image?query=cozy%20romance%20food%20series%20poster%2C%20warm%20small%20restaurant%20interior%20with%20hanging%20lights%2C%20steaming%20dishes%2C%20inviting%20orange%20and%20cream%20tones%2C%20no%20text&width=400&height=600&seq=tv-poster-04&orientation=portrait',
    genres: ['爱情', '美食'],
    region: '日韩',
    year: 2023,
    episodes: 16,
    status: '完结' as const,
    director: '小林优子',
    cast: ['中村花', '山下诚', '吉田葵'],
    rating: 7.9,
    popularity: 81,
    synopsis:
      '一家开在街角的深夜食堂，店主是一位话不多却厨艺了得的年轻人。形形色色的客人带着各自的故事而来，在一碗热汤面前卸下防备。美食与情感交织，治愈了每一个深夜归家的人。'
  },
  {
    id: 'tv-5',
    kind: 'tv' as const,
    title: '星际学院',
    poster: 'https://readdy.ai/api/search-image?query=sci-fi%20youth%20series%20poster%2C%20futuristic%20space%20academy%20with%20glass%20domes%2C%20glowing%20holographic%20panels%2C%20deep%20blue%20and%20cyan%20tones%2C%20ambitious%20futuristic%20mood%2C%20no%20text&width=400&height=600&seq=tv-poster-05&orientation=portrait',
    genres: ['科幻', '青春'],
    region: '国产',
    year: 2025,
    episodes: 30,
    status: '连载' as const,
    director: '洛星河',
    cast: ['江翎', '楚墨', '安可'],
    rating: 8.1,
    popularity: 87,
    synopsis:
      '在一所培养星际探索人才的顶尖学院里，一群来自不同星球的少年少女为了同一个目标聚到一起。竞争、友情与理想在他们之间碰撞，而一场突如其来的危机，将考验他们的勇气与担当。'
  },
  {
    id: 'tv-6',
    kind: 'tv' as const,
    title: '权力之巅',
    poster: 'https://readdy.ai/api/search-image?query=political%20drama%20series%20poster%2C%20grand%20marble%20government%20hall%2C%20lone%20figure%20on%20a%20long%20staircase%2C%20cold%20grey%20and%20deep%20navy%20tones%2C%20tense%20authoritative%20mood%2C%20no%20text&width=400&height=600&seq=tv-poster-06&orientation=portrait',
    genres: ['剧情', '政治'],
    region: '欧美',
    year: 2024,
    episodes: 20,
    status: '完结' as const,
    director: 'Richard Cole',
    cast: ['Michael Grant', 'Elena Ross', 'David Shaw'],
    rating: 8.9,
    popularity: 95,
    synopsis:
      '在一场关乎国家走向的权力更迭中，理想、野心与背叛同时上演。一位年轻的幕僚被卷入高层博弈的漩涡，不得不在原则与生存之间做出艰难抉择。剧集节奏紧凑、对白锋利，堪称政治题材的教科书之作。'
  },
  {
    id: 'tv-7',
    kind: 'tv' as const,
    title: '山间人家',
    poster: 'https://readdy.ai/api/search-image?query=warm%20family%20life%20drama%20series%20poster%2C%20traditional%20countryside%20village%20houses%20among%20green%20hills%2C%20soft%20morning%20light%2C%20peaceful%20earthy%20tones%2C%20no%20text&width=400&height=600&seq=tv-poster-07&orientation=portrait',
    genres: ['家庭', '生活'],
    region: '国产',
    year: 2023,
    episodes: 42,
    status: '完结' as const,
    director: '田守拙',
    cast: ['何大山', '陈月娥', '何小满'],
    rating: 8.4,
    popularity: 83,
    synopsis:
      '一个普通山村家庭十几年的生活变迁，浓缩了三代人的悲欢离合。从外出务工到返乡创业，从隔阂到和解，平凡的日子里藏着最动人的力量。剧集质朴真实、情感细腻，引发无数观众共鸣。'
  },
  {
    id: 'tv-8',
    kind: 'tv' as const,
    title: '魔法学园',
    poster: 'https://readdy.ai/api/search-image?query=magical%20fantasy%20school%20series%20poster%2C%20grand%20castle%20academy%20with%20glowing%20floating%20runes%2C%20enchanting%20purple%20and%20gold%20sparks%2C%20whimsical%20mysterious%20atmosphere%2C%20no%20text&width=400&height=600&seq=tv-poster-08&orientation=portrait',
    genres: ['奇幻', '冒险'],
    region: '日韩',
    year: 2025,
    episodes: 24,
    status: '连载' as const,
    director: '宫本彻',
    cast: ['藤原莲', '白石枫', '相川凛'],
    rating: 8.0,
    popularity: 85,
    synopsis:
      '在一所隐藏于结界之中的魔法学园，新入学的少年被判定为"无属性"施法者。然而他意外觉醒了失传已久的古老魔法。为了守护学园与同伴，他必须解开自身力量背后的秘密。充满想象力的奇幻成长故事。'
  },
  {
    id: 'tv-9',
    kind: 'tv' as const,
    title: '破案笔记',
    poster: 'https://readdy.ai/api/search-image?query=crime%20thriller%20series%20poster%2C%20dim%20police%20evidence%20room%20with%20case%20boards%2C%20single%20desk%20lamp%20light%2C%20gritty%20desaturated%20blue%20grey%20tones%2C%20tense%20mood%2C%20no%20text&width=400&height=600&seq=tv-poster-09&orientation=portrait',
    genres: ['犯罪', '悬疑'],
    region: '国产',
    year: 2024,
    episodes: 32,
    status: '完结' as const,
    director: '陆行舟',
    cast: ['秦越', '白薇', '老周'],
    rating: 8.2,
    popularity: 88,
    synopsis:
      '一名擅长从细节入手的老刑警，带领年轻的搭档接手一系列看似毫无关联的案件。随着一本旧笔记被翻开，多年前的真相逐渐浮现。剧集以扎实的刑侦细节和层层反转的叙事赢得口碑。'
  },
  {
    id: 'tv-10',
    kind: 'tv' as const,
    title: '海边小镇',
    poster: 'https://readdy.ai/api/search-image?query=healing%20romance%20series%20poster%2C%20quiet%20seaside%20town%20with%20wooden%20pier%20at%20golden%20hour%2C%20gentle%20ocean%20waves%2C%20soft%20warm%20pastel%20tones%2C%20calm%20soothing%20atmosphere%2C%20no%20text&width=400&height=600&seq=tv-poster-10&orientation=portrait',
    genres: ['爱情', '治愈'],
    region: '日韩',
    year: 2023,
    episodes: 12,
    status: '完结' as const,
    director: '松本惠',
    cast: ['长谷川海', '工藤遥', '石田凉'],
    rating: 7.7,
    popularity: 76,
    synopsis:
      '一位厌倦了大城市生活的插画师回到故乡的海边小镇，在一家旧书店里找到了久违的平静。与书店主人的相处，让她重新理解了生活的意义。节奏舒缓、画面唯美，是一部能让人慢下来的治愈系作品。'
  }
];